<template>
    <section>
        <v-text-field
            v-model="searchQuery"
            label="Zoeken"
            clearable
            class="mb-4"
            outlined
            rounded
            hide-details="auto"
        ></v-text-field>
        <v-card v-if="showOrganisationTypeFilter" class="facet-card mb-4" elevation="0">
            <v-card-text>
                <strong>Type dienstverlener</strong>
                <ul class="list-unstyled">
                    <li v-for="option in organisationTypeOptions" :key="option.value">
                        <v-checkbox
                            :label="option.label+' ('+countByOrganisationType(option.value)+')'"
                            :value="option.value"
                            v-model="selectedOrganisationTypes"
                            multiple
                            color="secondary"
                            hide-details="auto"
                        ></v-checkbox>
                    </li>
                </ul>
            </v-card-text>
        </v-card>
        <div v-for="facet in facets" :key="facet.id">
            <v-card class="facet-card mb-4" elevation="0">
                <v-card-text>
                    <strong>{{ facet.name }}</strong>
                    <ul class="list-unstyled">
                        <li v-for="choice in facet.choices" :key="choice.id">
                            <FacetFilter :facet="facet" :choice="choice"></FacetFilter>
                        </li>
                    </ul>
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import FacetFilter from "./FacetFilter";

const ORGANISATION_TYPE_OPTIONS = [
    { value: 'professional', label: 'Professionalisering' },
    { value: 'sustainable_employability', label: 'Duurzame inzetbaarheid' },
];

export default {
    name: "FilterList",
    components: {FacetFilter},
    computed: {
        searchQuery: {
            get () { return this.filters.searchQuery; },
            set (value) { this.$store.dispatch('organisation/updateSearchQuery', value)}
        },
        selectedOrganisationTypes: {
            get () { return this.filters.organisationTypes || []; },
            set (value) { this.$store.dispatch('organisation/updateOrganisationTypeFilter', value)}
        },
        organisationTypeOptions () { return ORGANISATION_TYPE_OPTIONS; },
        // Toon het type-filter alleen wanneer de weergave niet al tot één type beperkt is
        // (dus zonder dashboard-type of via de gecombineerde knop).
        showOrganisationTypeFilter () {
            return !this.filters.organisationType || this.filters.organisationType === 'professional_sustainable';
        },
        ...mapState({
            filters: state => state.organisation.filters,
            organisations: state => state.organisation.organisations,
        }),
        ...mapGetters('organisation', ['visibleFacets']),
        facets () { return this.visibleFacets; },
    },
    methods: {
        countByOrganisationType (type) {
            return this.organisations.filter(organisation => organisation.organisationType === type).length;
        },
    },
}
</script>

<style scoped>

</style>
